module.exports = __webpack_public_path__ + "static/media/fourth_first_bank4.8e8bed50.jpg";